import { useContext } from 'react';

import { HoneycombTickFormatter } from '../context/honeycomb-tick-formatter.context.js';

export const useHoneycombTickFormatter = () =>
  useContext(HoneycombTickFormatter);
